var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40136c19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-carousel-slide":"img-src"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generales/Chatbot.vue
// module id = RZUv
// module chunks = 1